// Shared purchase-order UI primitives: PO status/payment labels and colors,
// plus es-AR money/date formatting. Used by the PO list and detail pages
// (deduplicated out of apps/web/src/pages/PurchaseOrders.tsx and
// PurchaseOrderDetail.tsx).

export type POStatus =
  | 'draft'
  | 'sent'
  | 'partial_received'
  | 'partial'
  | 'received'
  | 'closed'
  | 'cancelled';

export const statusColors: Record<POStatus | string, string> = {
  draft: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200',
  sent: 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300',
  partial_received: 'bg-amber-100 text-amber-700',
  partial: 'bg-amber-100 text-amber-700',
  received: 'bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300',
  closed: 'bg-indigo-100 text-indigo-700',
  cancelled: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300',
};

export const statusLabels: Record<POStatus | string, string> = {
  draft: 'Borrador',
  sent: 'Enviada',
  partial_received: 'Entregas parciales',
  partial: 'Entregas parciales',
  received: 'Entregada',
  closed: 'Cerrada',
  cancelled: 'Cancelada',
};

export const paymentStatusColors: Record<string, string> = {
  unpaid: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300',
  partial_paid: 'bg-amber-100 text-amber-700',
  paid: 'bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300',
};

export const paymentStatusLabels: Record<string, string> = {
  unpaid: 'Sin pagar',
  partial_paid: 'Pago parcial',
  paid: 'Pagada',
};

export function formatMoney(value: number | string | null | undefined): string {
  const num = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (!Number.isFinite(num)) return '$0,00';
  return `$${num.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '-';
  return new Date(value).toLocaleDateString('es-AR');
}